import { Controller } from "@hotwired/stimulus"
import { initFlowbite } from 'flowbite';

export default class extends Controller {
  static targets = [ 'toggle' ];
  declare readonly toggleTarget: HTMLButtonElement;
  timeout: number | undefined;

  get clipboard() {
    return (window as any).FlowbiteInstances.getInstance('CopyClipboard', this.toggleTarget.dataset.copyToClipboardTarget);
  }

  connect() {
    if (!this.clipboard) initFlowbite();
    this.clipboard.updateOnCopyCallback(() => {
      this.showSuccess();

      this.timeout = setTimeout(() => {
        this.reset();
      }, 2000);
    })
  }

  disconnect() {
    this.clipboard.destroyAndRemoveInstance();
    if (this.timeout) {
      clearTimeout(this.timeout);
      this.timeout = undefined;
    }
  }

  reset = () => {
    const defaultMsg = this.element.querySelector('.default-message'),
        successMsg = this.element.querySelector('.success-message');
    successMsg.classList.add('hidden');
    defaultMsg.classList.remove('hidden');
    if (this.timeout) {
      clearTimeout(this.timeout);
      this.timeout = undefined;
    }
  }

  showSuccess() {
    const defaultMsg = this.element.querySelector('.default-message'),
        successMsg = this.element.querySelector('.success-message');
    defaultMsg.classList.add('hidden');
    successMsg.classList.remove('hidden');
  }
}
